import { AppShell } from '@/components/AppShell';

interface CardPlaceholderProps {
  title: string;
}

export function CardPlaceholder({ title }: CardPlaceholderProps) {
  return (
    <AppShell title={title}>
      <div className="rounded-lg border border-dashed border-slate-300 bg-white p-12 text-center dark:border-slate-700 dark:bg-slate-900">
        <p className="text-sm text-slate-600 dark:text-slate-400">
          This screen is under construction. The form and logic for this module land in a
          later pass.
        </p>
      </div>
    </AppShell>
  );
}
